let str = window.location.search
let subStr = "testDev";
if (str.includes(subStr)) {
	
	var Api = {
		ApiUrl: 'https://gw-test.zzqz2024.com', //测试,
		traceurl: "https://trace-test.zzqz2024.com",
	}

} else {

	var Api = {
		ApiUrl: 'https://gw.zzqz2024.com', //线上,.
		traceurl:"https://trace.zzqz2024.com",
	}
}
export default Api